import { UPDATE_SELECTED_LOCATION, UPDATE_SELECTED_GANG } from '../../actions/types';

const initState = {
  employees: []
};


export default function listReducer(state=initState, action) {
  switch (action.type) {
    case UPDATE_SELECTED_LOCATION:
      return {
        ...state,
        employees: action.payload.employees
      };
    case UPDATE_SELECTED_GANG:
      return {
        ...state,
        employees:action.payload.employees
      }
    default:
      return state;
  }
}


/* END */



// WEBPACK FOOTER //
// ./src/reducers/alerts/list_reducer.js